export default __webpack_public_path__ + "static/media/sAVAX.178d0ccc.png";